import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, Box, Button, CircularProgress, Container, Snackbar, Typography } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { getFiltrarObsequios, getUsuarios, postActivarObsequio, postDesactivarObsequio } from "../../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Add, Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ObsequiosHeader from "./components/ObsequiosHeader";
import ObsequiosTableComponent from "./components/ObsequiosTableComponent";
import ObsequiosFiltrosComponents from "./components/ObsequiosFiltrosComponents";
import ModalToggleComponents from "./components/ModalToggleComponents";


function ObsequiosPage() {
    const [loading, setLoading] = useState(false);
    const [dataObsequios, setDataObsequios] = useState([]);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);
    const [busqueda, setBusqueda] = useState("");
    const [loadingCargar, setLoadingCargar] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [obsequioSelected, setObsequioSelected] = useState(null);
    const [loadingDescargar, setLoadingDescargar] = useState(false);




    //estado alert
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');








    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);










    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarObsequios = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            titulo: busqueda
        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        getFiltrarObsequios(stateToken?.access_token, body)
            .then(response => {
                console.log("response==>getFiltrarObsequios", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response?.data?.data?.length > 0) {
                    setDataObsequios(response.data.data);
                    setLoading(true);
                } else {
                    setDataObsequios([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.data?.current_page,
                    per_page: response?.data?.per_page,
                    total: response?.data?.total,
                    last_page: response?.data?.last_page
                });


            })
            .catch(error => {
                console.log("error==>getFiltrarObsequios", error);
                setDataObsequios([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };








    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (busqueda.length > 2) {

                handleApiFiltrarObsequios(1);
            } else {
                handleApiFiltrarObsequios(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, busqueda, perPage]);










    //=============================================funcion para editar
    const handleEditClick = (item) => {
        // console.log('Edit', id, row);
        history('/app/admin/obsequios/obsequios-detalle/' + item?.id, {
            state: { data: item }
        });
    };

    //=============================================funcion para ver
    const handleVerObsequio = (item) => {
        // console.log('View', id, row);
        history('/app/admin/obsequios/obsequios-detalle/' + item?.id + '?mode=view');
    };

    //=============================================funcion para toggle
    const handleToggle = (item) => {
        console.log('Toggle', item);
        setOpenModal(true);
        setObsequioSelected(item);

    };






    const handleAddObsequio = () => {
        history('/app/admin/obsequios/obsequios-add');
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };

    const handleSearchChange = (value) => {
        setBusqueda(value);
    };



    //=============================================funcion para descargar el qr
    const handleCloseModal = () => {
        setOpenModal(false);
        setObsequioSelected(null);
    };


    //============================================================ funcion para filtrar por estado y nombre
    const handleApiActivarObsequio = () => {
        setLoadingDescargar(true);
        postActivarObsequio(stateToken?.access_token, obsequioSelected?.id)
            .then(response => {
                console.log("response==>getFiltrarObsequios", response);

                setLoadingDescargar(false);
                setOpenModal(false);
                setObsequioSelected(null);

                //mensaje
                setMensaje(response?.data?.message || "Obsequio actualizado correctamente");
                setSeverity("success");
                setOpen(true);

                handleApiFiltrarObsequios(1);


            })
            .catch(error => {
                console.log("error==>getFiltrarObsequios", error);

                setLoadingDescargar(false);
                setOpenModal(false);
                setObsequioSelected(null);

                //mensaje
                setMensaje(error?.response?.data?.message || "Error al actualizar el obsequio");
                setSeverity("error");
                setOpen(true);

                handleApiFiltrarObsequios(1);

            })
    };


    //============================================================ funcion para filtrar por estado y nombre
    const handleApiDesactivarObsequio = () => {
        setLoadingDescargar(true);
        postDesactivarObsequio(stateToken?.access_token, obsequioSelected?.id)
            .then(response => {
                console.log("response==>getFiltrarObsequios", response);

                setLoadingDescargar(false);
                setOpenModal(false);
                setObsequioSelected(null);

                //mensaje
                setMensaje(response?.data?.message || "Obsequio actualizado correctamente");
                setSeverity("success");
                setOpen(true);

                handleApiFiltrarObsequios(1);
            })
            .catch(error => {
                console.log("error==>getFiltrarObsequios", error);
                setLoadingDescargar(false);
                setOpenModal(false);
                setObsequioSelected(null);

                //mensaje
                setMensaje(error?.response?.data?.message || "Error al actualizar el obsequio");
                setSeverity("error");
                setOpen(true);

                handleApiFiltrarObsequios(1);


            })
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <ObsequiosHeader
                            title="Obsequios"
                            subtitle="Administra y supervisa los obsequios de la plataforma."
                            handleAdd={handleAddObsequio}
                        />



                        <div>


                            <ObsequiosFiltrosComponents
                                searchValue={busqueda}
                                onSearchChange={handleSearchChange}
                            // statusFilter={statusFilter}
                            // onStatusChange={handleStatusChange}
                            // statusOptions={statusOptions}
                            />


                            <ObsequiosTableComponent
                                data={dataObsequios}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarObsequios}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                                handleVerObsequio={handleVerObsequio}
                                handleToggle={handleToggle}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>


                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}



                <ModalToggleComponents
                    openModal={openModal}
                    loading={loadingDescargar}
                    handleCloseModal={handleCloseModal}
                    obsequioSelected={obsequioSelected}

                    handleApiActivarObsequio={handleApiActivarObsequio}
                    handleApiDesactivarObsequio={handleApiDesactivarObsequio}
                />



                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>
            </div>
        </HeaderCustom>
    );
}

export default ObsequiosPage;